import { TableFirstColumnWidth } from "src/components-mui/base/table-scrollable/table-scrollable.types";

export const WIKIFOLIO_TABLE_FIRST_COLUMN_WIDTH: TableFirstColumnWidth = ["229px", "229px", "260px", "384px"];
